import {CustomCellRendererProps} from '@ag-grid-community/react';
import {DVIR} from "@ots-frontend/ots-data";
import {IconChecklist} from "@tabler/icons-react";

export type DVIRCellProps = CustomCellRendererProps<DVIR> & {}

export const DVIRCell = (props: DVIRCellProps) => {
  const {value} = props

  if (!value) {
    return undefined
  }

  return <IconChecklist size={14}/>
}
